/**
 * Custom icon components for things Lucide doesn't have.
 * All accept: size, color, strokeWidth, className
 */

export function CrossIcon({ size = 16, color = 'currentColor', strokeWidth = 2.5, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <line x1="12" y1="3" x2="12" y2="21" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
      <line x1="5"  y1="9" x2="19" y2="9"  stroke={color} strokeWidth={strokeWidth} strokeLinecap="round"/>
    </svg>
  );
}

export function PrayingHandsIcon({ size = 16, color = 'currentColor', strokeWidth = 1.75, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      {/* Left hand */}
      <path d="M6 18 C4 16 3 13 4 10 L6 6 C6.5 4.5 8 4 9 5 L10 7" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      {/* Right hand */}
      <path d="M18 18 C20 16 21 13 20 10 L18 6 C17.5 4.5 16 4 15 5 L14 7" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      {/* Fingers meeting */}
      <path d="M10 7 L12 4 L14 7" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 10 L12 7 L15 10" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 14 L12 10 L16 14" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 18 L12 13 L18 18" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/** Small filled circle for priority indicators */
export function PriorityDot({ color, size = 8 }) {
  return (
    <span style={{
      display: 'inline-block',
      width: size, height: size,
      borderRadius: '50%',
      background: color,
      flexShrink: 0,
    }}/>
  );
}

/** Dot badge for calendar — replaces emoji dots */
export function CalDot({ color, prayed }) {
  return (
    <span style={{
      display: 'inline-block',
      width: 6, height: 6,
      borderRadius: '50%',
      background: color,
      opacity: prayed ? 0.3 : 0.85,
      flexShrink: 0,
    }}/>
  );
}
